import {
  FilterButton,
  ModalContainer,
  ModalForm,
  ModalFormActions,
  ModalTitle,
  WarningNotice,
} from "../shared";
import { ModalBodyText } from "./AdminTranslations.styles";

interface IDiscardTranslationsModalProps {
  dirtyCount: number;
  onDiscard: () => void;
  onClose: () => void;
}

/**
 * Confirms losing unsaved translation edits when switching survey (EN-5163).
 *
 * The ticket asks for unsaved-changes protection: Retool refetched on survey
 * change and the in-progress edits simply vanished. A `window.confirm` would
 * do the job but the portal has a modal slot and a convention that a
 * destructive action gets a real confirmation, so this is one.
 */
export function DiscardTranslationsModal({
  dirtyCount,
  onDiscard,
  onClose,
}: IDiscardTranslationsModalProps) {
  return (
    <ModalContainer>
      <ModalTitle>Discard unsaved translations?</ModalTitle>
      <ModalForm>
        <ModalBodyText>
          You have <strong>{dirtyCount}</strong> unsaved translation
          {dirtyCount === 1 ? "" : "s"} on this survey.
        </ModalBodyText>
        <WarningNotice>
          Switching survey discards them. This can&apos;t be undone.
        </WarningNotice>
        <ModalFormActions>
          <FilterButton variant="secondary" onClick={onClose}>
            Keep editing
          </FilterButton>
          <FilterButton variant="primary" onClick={onDiscard}>
            Discard and switch
          </FilterButton>
        </ModalFormActions>
      </ModalForm>
    </ModalContainer>
  );
}
